import axios from "axios";


const url = process.env.REACT_APP_BANKVERIFY_URL;


export const GetUserRole=async(module,setIsLoading,setData,handleAlertOpen)=>{
    try{
        setIsLoading(true)
        await axios.get(`${url}procurement/purchase/maker_checker`,{
            headers:{
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            },
            params:{
                collection_name:module
            }
        }
    )
    .then((res)=>{
        setIsLoading(false)
        setData(res.data)
    })
    .catch((err)=>{
        setIsLoading(false)
        handleAlertOpen(err.response.data.error,"error")
    })
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response&&error.response.data?error.response.data.error:"Something went wrong","error")
    }
}
